/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Max_PlayersInputs */



/**
* | output |
* | --- |
* | "Registration cap (optional)" |
*
* @param {Tfield_Max_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_max_players = /** @type {((inputs?: Tfield_Max_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Max_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plafond des inscriptions (optionnel)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tope de inscripciones (opcional)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Teto de inscrições (opcional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tetto iscrizioni (opzionale)")
	return /** @type {LocalizedString} */ ("Registration cap (optional)")
});